module.exports = __webpack_public_path__ + "img/home_depot.0bcb5427.svg";